import { ActionTree } from "vuex";
import { RootState } from "..";
import eventsApi from "../../api/events.api";
import { SportEventStatusCode } from "./../../models/sport-events.model";
import { RootActionTypes } from "./../root-actions";
import { SportEventsState } from "./index";
import { SportEventsMutationTypes } from "./sport-events.mutations";
import * as Sentry from "@/utils/logger.util";

export const SportEventsActionTypes = {
  FetchSportEvents: "FETCH_SPORT_EVENTS"
};

export const actions: ActionTree<SportEventsState, RootState> = {
  async [SportEventsActionTypes.FetchSportEvents](
    { commit, dispatch },
    payload: { search?: string; type?: SportEventStatusCode; page?: number }
  ) {
    try {
      const response = await eventsApi.getEvents(payload.page, payload.search, payload.type);
      commit(SportEventsMutationTypes.SetSportEvents, response.data);
    } catch (error) {
      Sentry.captureException(error);
      dispatch(RootActionTypes.HandleApiError, error, { root: true });
    }
  }
};
